<template>
  <div class="vx-col w-12/12">
    <!-- Search & Length -->
    <div class="vx-row mb-6">
      <!-- <div class="flex flex-start ml-5" style="width: 50%">
        <v-select
          style="width: 100px"
          :options="limits"
          :clearable="false"
          v-model="length"
        />
      </div> -->

      <div class="mr-auto"></div>

      <div class="flex flex-end">
        <vs-input
          class="mb-4 md:mb-0 mr-4 round"
          v-model="search"
          placeholder="Search..."
        />
      </div>
    </div>

    <!-- TABLE -->
    <vs-table
      :stripe="propsParams.stripe"
      bordered
      :data="paginatedData"
      @sort="handleSort"
    >
      <template slot="thead">
        <slot name="thead"></slot>

        <template v-for="(h, idx) in header">
          <vs-th
            :key="idx"
            :width="h.width"
            :sort-key="h.sortable !== false ? h.value : null"
          >
            {{ h.text }}
          </vs-th>
        </template>
      </template>

      <tbody>
        <slot name="tbody" :rows="paginatedData"></slot>
      </tbody>
    </vs-table>

    <!-- PAGINATION -->
    <div class="vx-row mb-6">
      <div class="flex flex-start ml-5" style="font-size: 14px">
        {{ start }} - {{ end }} of {{ filteredData.length }}
      </div>

      <div class="mx-auto"></div>

      <div class="flex flex-end">
        <vs-pagination
          style="padding-top: 5px"
          :total="totalPage"
          v-model="page"
        />
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: { vSelect },

  props: {
    dataSource: Array,   // FULL dataset for client-side processing
    header: Array,
    propsParams: {
        type: Object,
        default: () => ({
        stripe: true       // DEFAULT VALUE ADDED
        })
    },
    limits: {
      type: Array,
      default: () => [5]
    }
  },

  data() {
    return {
      search: "",
      length: 10,
      page: 1,
      sortKey: "",
      sortOrder: "asc",
    };
  },

  computed: {
    /** 1. FILTER */
    filteredData() {
      if (!this.search) return this.dataSource;

      const s = this.search.toLowerCase();

      return this.dataSource.filter(row =>
        JSON.stringify(row).toLowerCase().includes(s)
      );
    },

    /** 2. SORT */
    sortedData() {
      if (!this.sortKey) return this.filteredData;

      return [...this.filteredData].sort((a, b) => {
        let x = a[this.sortKey];
        let y = b[this.sortKey];

        if (typeof x === "string") x = x.toLowerCase();
        if (typeof y === "string") y = y.toLowerCase();

        if (this.sortOrder === "asc") return x > y ? 1 : -1;
        return x < y ? 1 : -1;
      });
    },

    /** 3. PAGINATION */
    paginatedData() {
      const start = (this.page - 1) * this.length;
      return this.sortedData.slice(start, start + this.length);
    },

    totalPage() {
      return Math.ceil(this.filteredData.length / this.length);
    },

    start() {
      return this.filteredData.length === 0
        ? 0
        : (this.page - 1) * this.length + 1;
    },

    end() {
      const e = this.page * this.length;
      return e > this.filteredData.length ? this.filteredData.length : e;
    }
  },

  methods: {
    handleSort({ key, order }) {
      this.sortKey = key;
      this.sortOrder = order;
    }
  }
};
</script>
